
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/token/[tokenAddress]",
      function () {
        return require("private-next-pages/token/[tokenAddress].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/token/[tokenAddress]"])
      });
    }
  